"use strict";

import Server from "helpers/server";
import Events from "events/events";
import ElementReplacer from "helpers/element-replacer";
import UUID from "helpers/uuid";
import accessibility from "helpers/accessibility";
import { dataset } from "../polyfills/dataset";
import scrollToElement from "helpers/scrollToElement";
import jsonPageData from "helpers/json-page-data";
import Basket from "models/basket";
import Analytics from "helpers/analytics/analytics";
import { quantityFieldUpdatedEvent } from "./quantity-field";
import Accordion from "./accordions";
import AddToBasketMadeToMeasureForm from "./m2m-add-to-basket-form";
import initFormTooltips from "./tooltips";
import { dispatchEvent } from "helpers/analytics/AnalyticsEventDispatcher";
import { ReactAccordion } from "./accordion";
import FabricByLengthPriceCalculator from "./fabric-by-length/fabric-by-length-price-calculator";
import { numericInputsCreatedEvent } from "./numeric-input-maxlength";
import {
  showIfSizeSelectionHasErrors,
  scrollIfSizeSelectionHasErrors,
} from "./size-selection-errors";
import {
  scrollIfQuantityError,
  hasQuantityError,
  getQuantityErrorMessage,
} from "./quantity-error";
import DomUtils from "helpers/dom-utils";
import subtotalRecalculate from "../helpers/subtotal-recalculate";
import initShareModal, {
  unmount as unmountShareModal,
} from "../components/share-modal";
import initBrandLink, {
  unmount as unmountBrandLink,
} from "../components/brand-link";
import initWishListLoader, {
  unmount as unmountWishListLoader,
} from "../components/wish-list-loader";
import ClickAndCollectCountdown, {
  unmount as unmountClickAndCollect,
} from "../components/click-and-collect-countdown";
import { ProductEmailMe } from "../components/product-email";
import { initMinQuantity } from "../components/min-length-quantity";
import { placements } from "../helpers/recommendations";
import Tooltips from "../components/tooltips/tooltips";
import { async } from "q";

const { RECOMMENDATIONS_A2B_PLACEMENT } = placements;
let uuid = window.staticUUID ? window.staticUUID : UUID();
var qtySelected = 1;

if (canEnhanceAddToBasketForm()) {
  initAddToBasket();
  Events.addToBasketReinit.register(reInitAddToBasket);
}

function registerSizeNotSelected() {
  if (!window.isSizeSelected)
    window.isSizeSelected = () => {
      const sizeNotSelected = document.querySelector(
        'input[name="sizeNotSelected"]'
      );
      if (sizeNotSelected) {
        showIfSizeSelectionHasErrors();
        return false;
      }
      return true;
    };
}

function initAddToBasket() {
  registerSizeNotSelected();
  addToBasketButtonListeners();
  updateAddToBasketFormForCustomersBasket();
  setupMaxRollLengthMessage();
  enhanceFormForFabricByLength();
  initMinQuantity();
  initMiniBasketEvent();
  uuid = window.staticUUID ? window.staticUUID : UUID();
}

function reInitAddToBasket() {
  addToBasketButtonListeners();
  updateAddToBasketFormForCustomersBasket();
  enhanceFormForFabricByLength();
  initMinQuantity();
  initMiniBasketEvent();
  uuid = window.staticUUID ? window.staticUUID : UUID();
}

function canEnhanceAddToBasketForm() {
  return (
    "querySelector" in document &&
    document.querySelector(".add-to-basket-form .button")
  );
}

function addToBasketButtonListeners() {
  let addToBasketForm = document.querySelector(".add-to-basket-form");
  let addToBasketButton = document.querySelector(".add-to-basket-form .button");

  if (!(addToBasketButton && addToBasketForm)) {
    return;
  }

  addToBasketButton.addEventListener("click", (evt) => {
    evt.preventDefault();
    Events.onAddToBasket.trigger(window, null);
    addToBasket(addToBasketForm, addToBasketButton);
  });
}

function initMiniBasketEvent() {
  const goToBasket = document.querySelector(".mini-basket-trigger-link");
  if (goToBasket) {
    goToBasket.addEventListener("click", (e) => {
      if (window.isMinibasketLoaded === true) {
        e.preventDefault();
        const showMinibasketEvent = new CustomEvent(
          "jl-events.browser.showMinibasket",
          {
            detail: {
              source: "pdp",
            },
          }
        );
        window.dispatchEvent(showMinibasketEvent);
      }
    });
  }
}

function setupMaxRollLengthMessage() {
  document
    .querySelector("main")
    .addEventListener(quantityFieldUpdatedEvent, (evt) => {
      const quantity = parseInt(evt.detail.quantity);
      showOrHideMaxRollLengthMessageForQuantity(quantity);
    });
  showOrHideMaxRollLengthMessageForQuantity(1);
}

function showOrHideMaxRollLengthMessageForQuantity(quantity) {
  let maxRollLengthMessage = document.querySelector(
    ".maximum-roll-length-message"
  );
  if (!maxRollLengthMessage) {
    return;
  }

  let quantityInput = document.querySelector(".quantity-input");

  if (quantity > getMaximumRollLength()) {
    maxRollLengthMessage.classList.remove("u-audible");
    quantityInput.classList.add("u-input--global-feedback");
  } else {
    maxRollLengthMessage.classList.add("u-audible");
    quantityInput.classList.remove("u-input--global-feedback");
  }
}


const sendBasketRequest = async (
  addToBasketForm,
  addToBasketButton,
  stickyAddToBasket,
  success,
  failure
) => {
  let auth0Token = "";
  const auth0 = window.__auth0__ || window.auth0;
  if(auth0!=null){
    auth0Token = await auth0.getTokenIfAuthenticated();
  }
  addToBasketButton.classList.toggle("u-button-loader");
  addToBasketButton.classList.toggle("button--loading");
  dataset(addToBasketButton).addToBasketText = addToBasketButton.innerText;
  addToBasketButton.firstChild.nodeValue =
    dataset(addToBasketButton).addingToBasket;
  accessibility.alert(dataset(addToBasketButton).alertText, 100);
  addToBasketButton.setAttribute("disabled", "disabled");
  Server.getHtml(addToBasketForm.getAttribute("action"), {
    method: "POST",
    body: new FormData(addToBasketForm),
    credentials: "same-origin",
    headers: {
      auth0Token: auth0Token,
    },
  })
    .then((response) => updateAddToBasketForm(response, stickyAddToBasket, true))
    .then(() => scrollToConfirmation(stickyAddToBasket))
    .then(initBasketBtnAnalytics)
    .then(reInitAccordions)
    .then(() => refocusAddToBasketButton(stickyAddToBasket))
    .then(() => initMiniBasketEvent())
    .then(() => initFormTooltips("basket-form"))
    .then(() => initTooltips(".bundle-detail__content--specifications"))
    .then(() => {
      Events.basketQuantityUpdated.trigger(window, null);
      //event dispatched globally to trigger an action to update the user profile in the browse-ui header
      const basketQuantityUpdated = DomUtils.createEvent({
        eventName: "jl-events.browser.basketQuantityUpdated",
        element: window,
      });
      setTimeout(() => {
        basketQuantityUpdated.dispatch();
      }, 500);
    })
    .then(success)
    .catch((e) => {
      console.error(e);

      failure();
    });
};

export function addToBasket(
  addToBasketForm,
  addToBasketButton,
  stickyAddToBasket = false,
  success = () => {},
  failure = () => {}
) {
  if (document.querySelector('#quantity')) {
    qtySelected = document.querySelector('#quantity').value;
  }

  if (addToBasketButton.classList.contains("button--inactive")) {
    const type = (() => {
      const addToBasketButton = document.querySelector(
        ".add-to-basket-summary-and-cta button"
      );

      if (
        addToBasketButton &&
        addToBasketButton.id === "button--add-to-basket-preorder"
      ) {
        return "preorder";
      }

      if (document.querySelector(".curtains-preview-page-main")) {
        return "m2mcurtain";
      }

      if (document.querySelector(".m2m-roman-blinds-preview-page-main")) {
        return "m2mroman";
      }
      if (document.querySelector(".m2m-roller-blinds-preview-page-main")) {
        return "m2mroller";
      }

      if (
        addToBasketButton &&
        addToBasketButton.dataset &&
        addToBasketButton.dataset.productType
      ) {
        return addToBasketButton.dataset.productType;
      }

      return "standard";
    })();

    dispatchEvent("dataStateChange", {
      action: "addtobasketerror",
      type,
      buttonType: getButtonType(stickyAddToBasket),
    });
    Events.onAddToBasketError.trigger();

    Analytics.resetErrors();
    const m2mFormContainer = document.querySelector(".m2m-add-to-basket-form");

    if (m2mFormContainer) {
      //handle m2m form errors
      if (
        !m2mFormContainer.querySelector('input[name="termsAccepted"]').checked
      ) {
        const termsNotAcceptedError = document.querySelector(
          "#terms-not-accepted-error"
        );
        termsNotAcceptedError.classList.remove("u-hidden");
        Analytics.addError(
          "Please check the box to show you've read and understood the terms and conditions"
        );
        Analytics.publish();
      }
    } else {
      //handle size not selected errors
      showIfSizeSelectionHasErrors();
      Analytics.addError("Select a size");
      Analytics.publish();
    }
  } else {
    sendBasketRequest(
      addToBasketForm,
      addToBasketButton,
      stickyAddToBasket,
      success,
      failure
    );
  }
}

function reInitAccordions() {
  let bundlePage = document.querySelector(".bundle-page-main");
  if (bundlePage) {
    let accordions = document.querySelectorAll(
      ".add-to-basket-form [data-accordion]"
    ); //Re init only accordions that are replaced in add to basket form.
    if (accordions) {
      for (let i = 0; i < accordions.length; i++) {
        ReactAccordion.init(accordions[i], i);
      }
    }
  }
}

function refocusAddToBasketButton(stickyAddToBasket) {
  if (stickyAddToBasket) {
    return;
  }

  const button = document.querySelector(".add-to-basket-form .button");
  button.focus();
}

export function scrollToConfirmation(stickyAddToBasket) {
  if (hasQuantityError()) {
    return;
  }
  const enhancedPathToCheckoutDiv = document.getElementById(
    "enhanced-path-to-checkout-container"
  );

  if (enhancedPathToCheckoutDiv) {
    const {
      dataset: { enhancedPathToCheckoutEnabled },
    } = enhancedPathToCheckoutDiv;

    if (enhancedPathToCheckoutEnabled === "true") {
      return;
    }
  }

  const panel = document.querySelector(".add-to-basket-confirmation-message");

  if (stickyAddToBasket || !panel) {
    return;
  }

  const animateClass = "add-to-basket-confirmation-message--animate";

  panel.classList.add(animateClass);

  setTimeout(() => {
    const panelInner = document.querySelector(
      ".add-to-basket-confirmation-message__inner"
    );
    const panelInnerHeight = panelInner ? panelInner.offsetHeight : "";
    const windowHeight = window.innerHeight;
    const scrollOffset = Math.max(
      120,
      windowHeight / 2 - panelInnerHeight / 2 - 16
    );
    const { data: { placements = [] } = {} } = window.jlRecs || {};
    const existingPlacementData = placements.find(
      (p) => p.requestedPlacement === RECOMMENDATIONS_A2B_PLACEMENT
    );

    // if we show recommendations carousel inside the confirmation message then we set container height to 'auto'
    panel.style.height =
      existingPlacementData && existingPlacementData.total > 0
        ? "auto"
        : `${panelInnerHeight}px`;

    scrollToElement(panel, scrollOffset * -1);
  }, 100);
}

function initRecommendations() {
  const panel = document.querySelector(".add-to-basket-confirmation-message");

  if (!window.jlRecs || !window.jlRecs.refresh || !panel) {
    return;
  }

  const existingA2bPlacement = panel.querySelector(
    `jl-recommendations-panel[placement="${RECOMMENDATIONS_A2B_PLACEMENT}"]`
  );
  const panelInner = panel.querySelector(
    ".add-to-basket-confirmation-message__inner"
  );

  const injectRecommendationsPanelIntoA2bMessage = (placement) => {
    const script = document.createElement("jl-recommendations-panel");
    const isJoyfullyBold = document.querySelector('[data-test="joyfullyBold"]') !== null;
    script.setAttribute("productId", getProductId());
    script.setAttribute("skuId", getSkuId());
    script.setAttribute("placement", placement);
    script.setAttribute("maxProductsPerPage", 3);
    script.setAttribute("type", "small");
    script.setAttribute("allowRefresh", "true");
    script.setAttribute("autoLoad", "false");
    script.setAttribute("isJoyfullyBold", `${isJoyfullyBold}`);
    panelInner && panelInner.appendChild(script);
  };

  if (!existingA2bPlacement && panelInner) {
    injectRecommendationsPanelIntoA2bMessage(RECOMMENDATIONS_A2B_PLACEMENT);
  }

  const { data: { placements = [] } = {} } = window.jlRecs || {};
  const existingPlacementData = placements.find(
    (p) => p.requestedPlacement === RECOMMENDATIONS_A2B_PLACEMENT
  );

  if (!existingPlacementData) {
    window.jlRecs
      .refresh([RECOMMENDATIONS_A2B_PLACEMENT])
      .then(({ placements = [] } = {}) => {
        const requestedPlacement = placements.find(
          (p) => p.requestedPlacement === RECOMMENDATIONS_A2B_PLACEMENT
        );
        if (requestedPlacement && requestedPlacement.total > 0) {
          panel.style.height = "auto";
        } else {
          const panelInnerHeight = panelInner ? panelInner.offsetHeight : "";
          panel.style.height = `${panelInnerHeight}px`;
        }
      });
  } else {
    const panelInnerHeight = panelInner ? panelInner.offsetHeight : "";
    panel.style.height =
      existingPlacementData.total > 0 ? "auto" : `${panelInnerHeight}px`;
  }
}

function initBasketBtnAnalytics() {
  const button = document.querySelector(".add-to-basket-view-basket-link");

  if (!button) {
    return;
  }

  button.addEventListener("click", () => {
    document.body.dispatchEvent(new CustomEvent("pdp.basketPromptButton"));
  });
}

function updateAddToBasketFormForCustomersBasket() {
  if (Basket.containsProduct(getProductId())) {
    Server.getHtml(getProductPageWithBasketUrl(), {
      method: "GET",
      credentials: "same-origin",
    })
      .then((response) => updateAddToBasketForm(response, undefined, false))
      .then(() => scrollToConfirmation())
      .then(initBasketBtnAnalytics)
      .then(reInitAccordions)
      .then(() => initMiniBasketEvent())
      .then(() => {
        Events.basketQuantityUpdated.trigger(window, null);
        //event dispatched globally to trigger an action to update the user profile in the browse-ui header
        const basketQuantityUpdated = DomUtils.createEvent({
          eventName: "jl-events.browser.basketQuantityUpdated",
          element: window,
        });
        setTimeout(() => {
          basketQuantityUpdated.dispatch();
        }, 500);
      });
  }
}

function getProductPageWithBasketUrl() {
  let currentUrl = window.location.href.replace("#product", "");
  if (currentUrl.indexOf("inBasket=true") < 0) {
    let separator = "?";
    if (currentUrl.indexOf("?") > -1) {
      separator = "&";
    }
    currentUrl = currentUrl + separator + "inBasket=true&bypass=" + uuid;
  }

  return currentUrl;
}

function getProductId() {
  return jsonPageData.refetchData().productId || getProductPages().productId;
}

function getSkuId() {
  return jsonPageData.refetchData().skuId || getProductPages().displayedSku ;
}

function getTotalPrice() {
  return jsonPageData.refetchData().totalPrice || getProductPages().price;
}

function getProductPages() {
  if (jlData && jlData.page && jlData.page.productPages) {
    return jlData.page.productPages;
  }
  return {};
}
function getMaximumRollLength() {
  return parseInt(jsonPageData.refetchData().maximumRollLength);
}

function getButtonType(stickyAddToBasket) {
  return stickyAddToBasket ? "floating" : "static";
}

const initTooltips = (tooltipClass) => {
  const tooltips = new Tooltips({
    container: tooltipClass,
  });
  tooltips.init();
};

function updateAddToBasketForm(response, stickyAddToBasket, sendAddToBasketSuccess) {
  const type = (() => {
    const addToBasketButton = document.querySelector(
      ".add-to-basket-summary-and-cta button"
    );

    if (
      addToBasketButton &&
      addToBasketButton.id === "button--add-to-basket-preorder"
    ) {
      return "preorder";
    }

    if (document.querySelector(".curtains-preview-page-main")) {
      return "m2mcurtain";
    }

    if (document.querySelector(".m2m-roman-blinds-preview-page-main")) {
      return "m2mroman";
    }
    if (document.querySelector(".m2m-roller-blinds-preview-page-main")) {
      return "m2mroller";
    }

    if (
      addToBasketButton &&
      addToBasketButton.dataset &&
      addToBasketButton.dataset.productType
    ) {
      return addToBasketButton.dataset.productType;
    }

    return "standard";
  })();

  const buttonType = getButtonType(stickyAddToBasket);

  let doc = response.bodyDocument;
  ElementReplacer.replace(doc, ".add-to-basket-form");
  ElementReplacer.replace(doc, ".store-stock-component");
  ElementReplacer.replace(doc, "#enhanced-path-to-checkout-container");
  window.jlSwatchOrder && window.jlSwatchOrder.init();
  ProductEmailMe.init(".product-detail__email-me-container");

  if (response.analytics && response.analytics.error) {
    // For analytics purposes, they want to know error AND success so we raise both if there is an error

    if (
      response.analytics.error.message
        .toLowerCase()
        .includes("refresh your page and try again")
    ) {
      const atb = document.getElementById("button--add-to-basket");

      atb.setAttribute("disabled", "disabled");
      atb.classList.add("button--disabled");
    }

    dispatchEvent("dataStateChange", {
      action: "addtobasketerror",
      type,
      buttonType,
    });

    const errorMessageLower = response.analytics.error.message.toLowerCase();
    console.log('response.analytics.error.message.toLowerCase():');
    console.log(errorMessageLower);
    if (sendAddToBasketSuccess && errorMessageLower.match(/we only have \d+ of these available online.*added \d+ to your basket/)) {
      const errorMessageNums = errorMessageLower.match(/(\d+)(\d+)/g);
      console.log('Error message numbers:');
      console.log(errorMessageNums);
      dispatchEvent("dataStateChange", {
        action: "addtobasketsuccess",
        type,
        buttonType,
        qtyRequested: qtySelected,
        product: {
          itemPrice: getTotalPrice(),
          productId: getProductId(),
          qty: errorMessageNums[1],
          services: [],
          sku: getSkuId(),
        },
      });
    }

    let basketErrorEvent = {};

    if (hasQuantityError()) {
      basketErrorEvent.message = getQuantityErrorMessage();
    }

    Events.onAddToBasketError.trigger(basketErrorEvent);
  } else {
    if (sendAddToBasketSuccess) {
      dispatchEvent("dataStateChange", {
        action: "addtobasketsuccess",
        type,
        buttonType,
        qtyRequested: qtySelected,
        product: {
          itemPrice: getTotalPrice(),
          productId: getProductId(),
          qty: qtySelected,
          services: [],
          sku: getSkuId(),
        },
      });
    }
  }

  enhanceFormForMadeToMeasure();
  //enhanceFormForAsaf();
  enhanceFormForFabricByLength();
  initFormTooltips("basket-form");
  initTooltips(".bundle-detail__content--specifications");
  // ElementReplacer.replace(doc, '.size-groups-section');
  Events.tooltipsReinit.trigger();
  Events.quantityFieldsReplaced.trigger(window, null);
  scrollIfSizeSelectionHasErrors();

  scrollIfQuantityError();

  addToBasketButtonListeners();
  showOrHideMaxRollLengthMessageForQuantity(1);
  Analytics.updateAnalyticsFromResponse(response);
  FabricByLengthPriceCalculator.init();
  document.body.dispatchEvent(new CustomEvent(numericInputsCreatedEvent, {}));

  subtotalRecalculate.init();

  unmountShareModal();
  unmountBrandLink();
  unmountWishListLoader();
  unmountClickAndCollect();

  initShareModal();
  initBrandLink();
  initWishListLoader();
  ClickAndCollectCountdown();
  initMinQuantity();
  initRecommendations();
  return Promise.resolve();
}

function enhanceFormForMadeToMeasure() {
  const m2mFormContainer = document.querySelector(".m2m-add-to-basket-form");
  if (m2mFormContainer) {
    new AddToBasketMadeToMeasureForm(m2mFormContainer);
    const accordion = m2mFormContainer.querySelector(
      ".m2m-read-terms-and-conditions-accordion"
    );
    if (accordion) {
      new Accordion(accordion);
    }
  }
}

function enhanceFormForFabricByLength() {
  if (document.querySelector(".fbl-add-to-basket-conditions")) {
    const addToBasketButton = document.getElementById("button--add-to-basket");
    if (addToBasketButton) {
      const termsAcceptedBtn = document.querySelector(
        '.fbl-add-to-basket-conditions input[name="termsAccepted"]'
      );
      const termsNotAcceptedError = document.getElementById(
        "terms-not-accepted-error"
      );
      if (!termsAcceptedBtn.checked) {
        addToBasketButton.classList.add("button--inactive");
      }
      termsAcceptedBtn.addEventListener("change", () => {
        if (termsAcceptedBtn.checked) {
          addToBasketButton.classList.remove("button--inactive");
          termsNotAcceptedError.classList.add("u-hidden");
        } else {
          addToBasketButton.classList.add("button--inactive");
        }
      });
      addToBasketButton.addEventListener("click", () => {
        if (!termsAcceptedBtn.checked && termsNotAcceptedError) {
          termsNotAcceptedError.classList.remove("u-hidden");
          scrollToElement(termsNotAcceptedError, -130);
        }
      });
    }
    const accordion = document.querySelector(
      ".m2m-read-terms-and-conditions-accordion"
    );
    if (accordion) {
      new Accordion(accordion);
    }
  }
}
